import { array, intersect, partial, string, struct } from 'io-ts/Decoder';

import { Area } from '../ui/geometry';
import { RefItem } from '../user';

import { Id } from './Id';
import { Metadata } from './Metadata';
import { ParentId } from './ParentId';

export const Type = intersect(
	struct({
		id: Id,
		parentId: ParentId,
		text: string,
		createdAt: string,
		createdBy: RefItem,
	})
)(
	partial({
		metadata: Metadata,
		areas: array(Area),
	})
);
